import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(7, 17),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(7),
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(5),
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
    },
  },
  personalInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  customTextField: {
    boxShadow: theme.shadows[2],
  },
  statusIcon: {
    marginLeft: theme.spacing(0.5),
  },
  statusVerified: {
    color: theme.palette.success.main,
  },
  statusUnverified: {
    color: theme.palette.warning.main,
  },
  emailIcon: {
    marginLeft: theme.spacing(2),
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  receiptHeaderSection: {
    margin: 0,
    marginBottom: theme.spacing(1.5),
  },
  avatar: {
    width: 180,
    height: 180,
    fontSize: "3.6rem",
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.main,
    margin: "auto",
  },
  loaderWrapper: {
    display: "flex",
    justifyContent: "center",
  },
}));

export default useStyles;
